import { List } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";

import dots from "../../../../assets/pfdots.png";
import { SubmitButton, TextComponent } from "../../../../components";
import Modal from "../../../../components/modal/Modal";
import styles from "./GuestScreen3.module.css";

const GuestScreen3 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  const [isDetailsModal, setIsDetailsModal] = useState(false);
  const [name, setName] = useState("");
  const [img, setImg] = useState();
  const [role, setRole] = useState("");
  const [desc, setDesc] = useState("");

  const onShowDetails = (item) => {
    setIsDetailsModal(true);
    setImg(item?.image);
    setName(item?.name);
    setRole(item?.title);
    setDesc(item?.description);
  };
  return (
    <div className={styles.mainCont}>
      <TextComponent text={"Our Wedding Party"} textClass={styles.heading} />
      <List
        dataSource={
          WeddingWeb?.wedding_parties?.length > 0
            ? WeddingWeb?.wedding_parties
            : []
        }
        className={styles.list}
        grid={{ lg: 4, xxl: 5, xl: 5, xs: 2, md: 3, sm: 2 }}
        renderItem={(item, index) => {
          return (
            <div className={styles.listItem} key={index}>
              <div
                className={styles.userDetail}
                onClick={() => onShowDetails(item)}
              >
                <div className={styles.images}>
                  <img
                    src={item?.image ? item?.image : null}
                    className={styles.pfImg}
                  />
                  <img src={dots} className={styles.dots} />
                </div>
                <TextComponent text={item?.name} textClass={styles.name} />
                <TextComponent text={item?.title} textClass={styles.role} />
              </div>
            </div>
          );
        }}
      />
      <div className={styles.submitBtn}>
        <SubmitButton
          btnClass={styles.nextBtn2}
          title={"Next"}
          onClick={() => setCurrentStep((prev) => prev + 1)}
        />
      </div>
      <Modal
        isModalOpen={isDetailsModal}
        setIsModalOpen={setIsDetailsModal}
        closable={true}
        // pinkBg={true}
        onClose={() => {
          setImg();
          setName("");
          setRole("");
          setDesc("");
        }}
        // wideModal={true}
        // className={styles.DmodalContent}
      >
        <div className={styles.modalDiv}>
          <div className={styles.DuserDetail}>
            <div className={styles.images}>
              <img src={img} className={styles.DpfImg} />
              <img src={dots} className={styles.Ddots} />
            </div>
            <TextComponent text={name} textClass={styles.Dname} />
            <TextComponent text={role} textClass={styles.Drole} />
            <TextComponent text={desc} textClass={styles.desc} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GuestScreen3;
